import { isEmptyArray } from './assertions';
export const checkIsOutStock = (lineItems) => {
  const data = lineItems
    .map((item) => {
      if (item.projectSpecificData?.variants?.length) {
        const currentProduct = item.projectSpecificData.variants.find(
          (v) => v.sku === item.variant.sku,
        );
        if (currentProduct) {
          return {
            sku: currentProduct.sku,
            isOutOfStock:
              currentProduct.projectSpecificData?.availableQuantity < item.count,
          };
        }
      }
      return null;
    })
    .filter((item) => item);

  return (
    isEmptyArray(data) ||
    data
      .filter((d) => d)
      .some((d) => d.isOutOfStock)
  );
};
